<script setup lang="ts">
import { X, SquareCheck } from 'lucide-vue-next';
import type { LocationWithPrice } from '@optionway/models';

interface AirportGroupProperties {
  sectionLabel: string;
  airports: LocationWithPrice[];
  selectedAirports: string[];
  allSelected: boolean;
}

defineProps<AirportGroupProperties>();

const locationLabels = useLocationLabels();

const emit = defineEmits<{
  toggleAll: [];
  toggleAirport: [iataCode: string, value: boolean];
  solo: [iataCode: string];
}>();
</script>

<template>
  <div class="flex flex-col gap-3">
    <UiCustomFilterSectionHeader :label="sectionLabel">
      <UiButton
        variant="tertiary"
        color="gray"
        padding="none"
        class="w-fit gap-1 text-xs font-normal text-gray-600 [&_svg]:size-3.5"
        @click="emit('toggleAll')"
      >
        <component
          :is="allSelected ? X : SquareCheck"
          aria-hidden="true"
        />
        {{ allSelected ? $t('components.results.filters.deselectAll') : $t('components.results.filters.selectAll') }}
      </UiButton>
    </UiCustomFilterSectionHeader>
    <UiCustomFilterLabeledCheckbox
      v-for="airport in airports"
      :id="airport.iataCode ?? ''"
      :key="airport.iataCode ?? ''"
      :label="locationLabels.airport(airport.iataCode) || airport.iataCode || ''"
      :model-value="selectedAirports.includes(airport.iataCode ?? '')"
      @update:model-value="(val) => emit('toggleAirport', airport.iataCode ?? '', val)"
    >
      <template #trailing>
        <div class="flex w-fit items-center gap-1.5">
          <button
            type="button"
            class="text-base font-semibold text-text-accent-700 opacity-0 transition focus:opacity-100 group-hover:opacity-100"
            :aria-label="`${$t('components.results.filters.solo')} ${airport.name ?? airport.iataCode}`"
            @click.stop.prevent="emit('solo', airport.iataCode ?? '')"
          >
            {{ $t('components.results.filters.solo') }}
          </button>
          <span
            v-if="airport.price?.averagePerPax"
            class="text-base font-normal text-secondary-foreground"
            >{{ usePriceFormat(airport.price.averagePerPax) }}</span
          >
        </div>
      </template>
    </UiCustomFilterLabeledCheckbox>
  </div>
</template>
